export default {
  getSystemTransitionDivisionInfo: state => state.divisionInfo,
  getSystemTransitionList: state => state.gridData,
  getOriSystemTransitionList: state => state.oriGridData,
  getIamUserList: state => state.iamUserData,
  getSystemTransitionSearchParam: state => state.searchParam,
  getAdminYn: state => state.adminYn,
  getCutOverStatus: state => state.statusList,
};



// WEBPACK FOOTER //
// ./src/vuex/systemTransition/systemTransitionGetter.js